import { FunctionComponent, JSX, SyntheticEvent } from 'react'
import { Tab, Tabs as MuiTabs } from '@mui/material'
import styles from './tabs.module.scss'

interface TabsProps {
    value: number
    onChange: (event: SyntheticEvent, newValue: number) => void
    tabList: Array<string>
    className?: string
    classNameTab?: string
}

const Tabs: FunctionComponent<TabsProps> = ({ value, onChange, className, tabList, classNameTab }: TabsProps) => {
    return (
        <MuiTabs value={value} onChange={onChange} className={`${styles.Tabs} ${className}`}>
            {tabList.map(
                (tab: string, index: number): JSX.Element => (
                    <Tab
                        key={index}
                        label={tab}
                        className={`${value === index ? styles.ActiveTab : ''}
				${classNameTab}`}
                    />
                )
            )}
        </MuiTabs>
    )
}

export default Tabs
